import { Output } from "valibot";

import { getActiveCampaignFields } from "shared/api";
import {
  CHANGE_SHOW_FLOATING_STARTER_QUESTIONS,
  CHANGE_SHOW_FLOATING_WELCOME_MESSAGE_EVENT,
  CHANGE_STARTER_QUESTIONS_EVENT,
  CHANGE_WELCOME_MESSAGE,
} from "shared/events";
import { generateUuid } from "shared/functions";
import { CommandSchema } from "shared/schemas";
import { CurrentUserFormData } from "shared/types";

import { StarterQuestionsSchema } from "../schemas";

const handleActiveCampaignEmail = async (
  acEmail: string,
  currentUserFormData: CurrentUserFormData,
  setCurrentUserFormData: React.Dispatch<
    React.SetStateAction<CurrentUserFormData>
  >,
  token: string,
) => {
  const user = await getActiveCampaignFields({
    email: acEmail,
    token,
  });
  if (user) {
    const { first_name, last_name, welcome_message, email, phone } = user;

    if (!currentUserFormData) {
      setCurrentUserFormData({
        "First Name": first_name || "",
        "Last Name": last_name || "",
        Email: email || acEmail || "",
        Phone: phone || "",
      });
    }
    window.dispatchEvent(
      new CustomEvent(CHANGE_WELCOME_MESSAGE, {
        detail: welcome_message,
      }),
    );
  }
};

export const fetchCommand = (
  command: Output<typeof CommandSchema>,
  setWidgetExpanded: (newWidgetExpanded: boolean) => void,
  token: string,
  onSendRef: React.MutableRefObject<
    ((msg: string, chatUserId?: string) => Promise<void>) | undefined
  >,
  setCurrentUserFormData: React.Dispatch<
    React.SetStateAction<CurrentUserFormData>
  >,
  currentUserFormData: CurrentUserFormData,
) => {
  // Starter questions
  if (command.showStarterQuestions) {
    window.dispatchEvent(
      new CustomEvent(CHANGE_SHOW_FLOATING_STARTER_QUESTIONS, {
        detail: command.showStarterQuestions,
      }),
    );
  }
  if (command.setStarterQuestions) {
    const newStarterQuestions: Output<typeof StarterQuestionsSchema> =
      command.setStarterQuestions.map(question => ({
        id: generateUuid(),
        question,
      }));
    window.dispatchEvent(
      new CustomEvent(CHANGE_STARTER_QUESTIONS_EVENT, {
        detail: newStarterQuestions,
      }),
    );
  }

  // Welcome message
  if (command.showWelcomeMessage) {
    window.dispatchEvent(
      new CustomEvent(CHANGE_SHOW_FLOATING_WELCOME_MESSAGE_EVENT, {
        detail: command.showWelcomeMessage,
      }),
    );
  }
  if (command.setWelcomeMessage) {
    window.dispatchEvent(
      new CustomEvent(CHANGE_WELCOME_MESSAGE, {
        detail: command.setWelcomeMessage,
      }),
    );
  }

  // Show widget
  if (command.widget) {
    setWidgetExpanded(command.widget === "open");
  }

  // Send message
  if (command.sendMessage) {
    const { current: onSend } = onSendRef;
    if (!onSend) {
      // eslint-disable-next-line no-console
      return console.error("onSend() is not ready");
    }
    onSend(command.sendMessage);
  }

  if (command.activeCampaignEmail) {
    handleActiveCampaignEmail(
      command.activeCampaignEmail,
      currentUserFormData,
      setCurrentUserFormData,
      token,
    );
  }
};
